<template>
    <label
        class="d-flex align-items-center base-switch"
        :class="{'disabled': disabled}">
        <span
            class="custom-toggle flex-shrink-0"
            :class="switchClass">
            <input
                v-model="model"
                type="checkbox"
                :disabled="disabled">
            <span
                class="custom-toggle-slider rounded-circle"
                :class="toggleClass"
                :data-label-off="offText ? offText : useOnOffLabel ? $t('core.off') : $t('core.no')"
                :data-label-on="onText ? onText : useOnOffLabel ? $t('core.on') : $t('core.yes')" />
        </span>
        <span
            class="custom-control-base-switch"
            :class="{'font-weight-normal': modelValue}"><slot>{{ label }}</slot></span>
    </label>
</template>
<script>
export default {
    name: 'BaseSwitch',
    props: {
        modelValue: [Array, Boolean, Number],
        type: String,
        label: {type: String},
        disabled: {type: Boolean, default: false},
        useOnOffLabel: {type: Boolean, default: false},
        onText: {
            type: String,
        },
        offText: {
            type: String,
        }
    },
    computed: {
        switchClass() {
            const baseClass = 'custom-toggle-';
            if (this.type) {
                return baseClass + this.type
            }
            return ''
        },
        toggleClass() {
            const baseClass = 'custom-toggle-slider-';
            if (this.type) {
                return baseClass + this.type
            }
            return ''
        },
        model: {
            get() {
                return Array.isArray(this.modelValue) ? this.modelValue : !!this.modelValue;
            },
            set(modelValue) {
                this.$emit('update:modelValue', Array.isArray(modelValue) ? modelValue : !!modelValue);
            }
        }
    },
    methods: {
        triggerToggle() {
            this.model = !this.model;
        }
    }
};
</script>
<style lang="scss" scoped>
.custom-control-base-switch {
  margin-left: map-get($spacers, 3);
  cursor: pointer;
}

.base-switch.disabled {
  .custom-control-base-switch {
    color: $custom-control-label-disabled-color
  }
}

.custom-toggle-status {
  width: 67px
}

.custom-toggle {
  input:checked + .custom-toggle-slider-status::before {
    transform: translateX(43px)
  }
}

.disabled {
  .custom-control-base-switch {
    cursor: not-allowed;
  }

  .custom-toggle-slider {
    cursor: not-allowed;
  }
}
</style>
